'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const RestoreIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="RestoreIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        id="Archive-Restore--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Archive Restore Streamline Icon: https://streamlinehq.com</desc>
        <path
          stroke="rgba(61, 81, 123, 0.5)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M21.75 6.25v13c0 1.7 -1.3 3 -3 3H5.25c-1.7 0 -3 -1.3 -3 -3v-13"
          strokeWidth="1"
        ></path>
        <path
          stroke="rgba(61, 81, 123, 0.5)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M21.75 1.75H2.25c-0.8 0 -1.5 0.7 -1.5 1.5v3h22.5v-3c0 -0.8 -0.7 -1.5 -1.5 -1.5Z"
          strokeWidth="1"
        ></path>
        <path
          stroke="rgba(61, 81, 123, 0.5)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M12.05 10.35v7.8"
          strokeWidth="1"
        ></path>
        <path
          stroke="rgba(61, 81, 123, 0.5)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="m15.35 13.65 -3.3 -3.3 -3.4 3.3"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

RestoreIcon.propTypes = {
  sx: PropTypes.object
}
